import Card from "components/Card";
import Page from "components/Page";
import React, { useState, useEffect, useRef } from "react";
import constants from "../../../constants";
import { withTranslation } from "react-i18next";
import "./TeamConversation.scss";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import InternalTabContent from "./components/TabsContent/InternalTabContent";
import useTeamConversationState from "Messenger/hooks/useTeamConversationState";
import useSelectedAccountOwner from "Messenger/hooks/useSelectedAccountOwner";
import useChatNotificationDeepLink from "Messenger/hooks/useChatNotificationDeepLink";
import { Redirect } from "react-router-dom";
import { handleError } from "utils";
import MessageDot from "components/MessageDot";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import useModuleDisplayOwner, {
  getModuleDisplayOwnerName,
} from "hooks/useModuleDisplayOwner";
import LayoutVendor from "VendorManagement/components/LayoutVendor";
const tabsValues = [
  { key: "internal", value: "1" },
  { key: "external", value: "2" },
];
const TeamConversation = ({ t }) => {
  const [hubspotContainer, setContainer] = useState(null);
  const el = document.getElementById("hubspot-messages-iframe-container");

  if (!hubspotContainer && el) {
    setContainer(el);
  }

  useEffect(() => {
    if (hubspotContainer) {
      hubspotContainer?.remove();
    }
    return () => {
      if (hubspotContainer) {
        document?.body?.appendChild?.(hubspotContainer);
      }
    };
  }, [hubspotContainer]);

  const [currentChannel, setCurrentChannel] = useState(null);
  const {
    state: {
      selectedOwner,
      isStaff,
    },
  } = useSelectedAccountOwner({
    localStorageKey: constants.localStorageKeys.selectedChatAccountOwner,
    setCurrentChannel,
  });
  const {selectedId}=useAccountOwnerCommon();
  const displayOwner = useModuleDisplayOwner();
  const { state, updateMethods, otherMethods } = useTeamConversationState();
  const { activeTab, profile, isVendor } = state;
  const { setActiveTab } = updateMethods;
  const { handleBack } = otherMethods;
  const { pinnedChannelUrl } = useChatNotificationDeepLink({
    setCurrentChannel,
    setActiveTab,
    switchTeamTabs: !isVendor,
  });
const preservedRef=useRef(null);
useEffect(() => {
  if(selectedId) {
    if(!preservedRef.current) {
      preservedRef.current=selectedId
    }else if(preservedRef.current!==selectedId) {
      setCurrentChannel(null);
      preservedRef.current=selectedId
    }
  }
}, [selectedId]);
  if (isStaff) {
    if (!profile.isAdmin && !profile.isMessenger) {
      return <Redirect to={"/"} />;
    }
  }

  const chatBody = (
          <div className="common-tabs messenger-tabs">
            {!isVendor && (
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === "1" ? "active" : ""}
                  onClick={() => {
                    setCurrentChannel(null);
                    setActiveTab("1");
                  }}
                >
                  {t("messenger.internal")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "2" ? "active" : ""}
                  onClick={() => {
                    if (profile.isAccountOwner || profile.isAdmin) {
                      setCurrentChannel(null);
                      setActiveTab("2");
                    } else {
                      handleError(
                        new Error(t("messenger.externalChatAccessError"))
                      );
                    }
                  }}
                >
                  {t("messenger.external")}
                </NavLink>
              </NavItem>
            </Nav>
            )}
            {isVendor ? (
              <InternalTabContent
                currentUser={profile}
                externalTabActive
                selectedOwner={selectedOwner}
                currentChannel={currentChannel}
                setCurrentChannel={setCurrentChannel}
                isTabActive
                pinnedChannelUrl={pinnedChannelUrl}
              />
            ) : (
            <TabContent activeTab={activeTab}>
              {tabsValues.map((res) => {
                return (
                  <TabPane tabId={res.value} key={res.key}>
                    <InternalTabContent
                      currentUser={profile}
                      {...(res.value === "2"
                        ? { externalTabActive: true }
                        : { internalTabActive: true })}
                      selectedOwner={selectedOwner}
                      currentChannel={currentChannel}
                      setCurrentChannel={setCurrentChannel}
                      isTabActive={activeTab === res.value}
                      pinnedChannelUrl={pinnedChannelUrl}
                    />
                  </TabPane>
                );
              })}
            </TabContent>
            )}
          </div>
  );

  const page = (
    <div className="messenger-page-content">
      <Page onBack={handleBack} className="scheduler-page">
        <div className="page_title_margin_top">
          <h2 className="page-title mb-0 margin-fix">{t("messenger.teamConversation")}</h2>
            {isStaff && displayOwner?.id && (
              <div className="show-owner-name-text">
              {t("messenger.selectedAccountOwnerText")}
                  <span>
                    {` '${getModuleDisplayOwnerName(displayOwner)}' `}
                  </span>
                  <MessageDot /> {t("dashBoard.office")}
              </div>
            )}
        </div>
        <Card
          radius="10px"
          marginBottom="18px"
          shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
          cursor="default"
          className={"team-chat-card"}
        >
          {chatBody}
        </Card>
        
      </Page>
    </div>
  );

  if (isVendor) {
    return <LayoutVendor>{page}</LayoutVendor>;
  }

  return page;
};

export default withTranslation()(TeamConversation);
